// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"a7660db8","851":"eb287f4b"}[chunkId] + ".chunk.js";
};